var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_6632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H512.5V170.7H0.5V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 170.7H512.5V341.3H0.5V170.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 341.3H512.5V512H0.5V341.3Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 324.267C294.203 324.267 324.767 293.703 324.767 256C324.767 218.297 294.203 187.733 256.5 187.733C218.797 187.733 188.233 218.297 188.233 256C188.233 293.703 218.797 324.267 256.5 324.267Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 315.733C289.49 315.733 316.233 288.99 316.233 256C316.233 223.01 289.49 196.267 256.5 196.267C223.51 196.267 196.767 223.01 196.767 256C196.767 288.99 223.51 315.733 256.5 315.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 267.947C263.098 267.947 268.447 262.598 268.447 256C268.447 249.402 263.098 244.053 256.5 244.053C249.902 244.053 244.553 249.402 244.553 256C244.553 262.598 249.902 267.947 256.5 267.947Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32 266.865C317.002 267.086 318.545 265.902 318.767 264.22C318.988 262.538 317.804 260.995 316.122 260.773C314.44 260.552 312.897 261.736 312.675 263.418C312.454 265.1 313.638 266.643 315.32 266.865Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 315.733L258.548 279.893L256.5 262.827L254.452 279.893L256.5 315.733Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.504 281.718C312.071 282.368 313.868 281.623 314.518 280.056C315.167 278.488 314.423 276.691 312.855 276.042C311.288 275.393 309.491 276.137 308.841 277.705C308.192 279.272 308.936 281.069 310.504 281.718Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.04 313.698L252.294 279.609L254.733 262.594L248.338 278.549L241.04 313.698Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.007 294.819C303.353 295.852 305.282 295.598 306.315 294.252C307.348 292.906 307.094 290.978 305.748 289.945C304.402 288.912 302.473 289.166 301.44 290.512C300.407 291.858 300.661 293.786 302.007 294.819Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.633 307.731L246.327 277.716L253.087 261.912L242.78 275.668L226.633 307.731Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.41 305.275C291.442 306.621 293.371 306.875 294.717 305.842C296.063 304.809 296.317 302.88 295.284 301.534C294.251 300.188 292.323 299.935 290.977 300.967C289.631 302 289.377 303.929 290.41 305.275Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.262 298.238L241.053 274.343L251.673 260.827L238.157 271.447L214.262 298.238Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.501 312.372C277.15 313.94 278.947 314.684 280.515 314.035C282.082 313.386 282.827 311.588 282.177 310.021C281.528 308.454 279.731 307.709 278.164 308.358C276.596 309.008 275.852 310.805 276.501 312.372Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77 285.867L236.832 269.72L250.588 259.413L234.784 266.173L204.77 285.867Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.229 315.628C261.451 317.31 262.994 318.494 264.676 318.273C266.358 318.051 267.542 316.508 267.321 314.826C267.099 313.144 265.556 311.96 263.874 312.181C262.192 312.403 261.008 313.946 261.229 315.628Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.802 271.46L233.951 264.162L249.906 257.767L232.891 260.206L198.802 271.46Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.635 314.82C245.414 316.502 246.598 318.045 248.28 318.267C249.962 318.488 251.505 317.304 251.727 315.622C251.948 313.94 250.764 312.397 249.082 312.175C247.4 311.954 245.857 313.138 245.635 314.82Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.767 256L232.607 258.048L249.673 256L232.607 253.952L196.767 256Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.782 310.004C230.132 311.571 230.877 313.368 232.444 314.018C234.012 314.667 235.809 313.923 236.458 312.355C237.107 310.788 236.363 308.991 234.795 308.341C233.228 307.692 231.431 308.436 230.782 310.004Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.802 240.54L232.891 251.794L249.906 254.233L233.951 247.838L198.802 240.54Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.681 301.507C216.648 302.853 216.902 304.782 218.248 305.815C219.594 306.848 221.522 306.594 222.555 305.248C223.588 303.902 223.334 301.973 221.988 300.94C220.642 299.907 218.714 300.161 217.681 301.507Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77 226.133L234.784 245.827L250.588 252.587L236.832 242.28L204.77 226.133Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.225 289.91C205.879 290.942 205.625 292.871 206.658 294.217C207.691 295.563 209.62 295.817 210.966 294.784C212.312 293.751 212.565 291.823 211.533 290.477C210.5 289.131 208.571 288.877 207.225 289.91Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.262 213.762L238.157 240.553L251.673 251.173L241.053 237.657L214.262 213.762Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.128 276.001C198.56 276.65 197.816 278.447 198.465 280.015C199.115 281.582 200.912 282.326 202.479 281.677C204.047 281.028 204.791 279.231 204.142 277.663C203.492 276.096 201.695 275.352 200.128 276.001Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.633 204.269L242.78 236.332L253.087 250.088L246.327 234.284L226.633 204.269Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.872 260.729C195.19 260.951 194.006 262.494 194.227 264.176C194.449 265.858 195.992 267.042 197.674 266.821C199.356 266.599 200.54 265.056 200.319 263.374C200.097 261.692 198.554 260.508 196.872 260.729Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.04 198.302L248.338 233.451L254.733 249.406L252.294 232.391L241.04 198.302Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68 245.135C195.998 244.914 194.455 246.098 194.233 247.78C194.012 249.462 195.196 251.005 196.878 251.227C198.56 251.448 200.103 250.264 200.325 248.582C200.546 246.9 199.362 245.357 197.68 245.135Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 196.267L254.452 232.107L256.5 249.173L258.548 232.107L256.5 196.267Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.496 230.282C200.929 229.632 199.132 230.377 198.482 231.944C197.833 233.512 198.577 235.309 200.145 235.958C201.712 236.607 203.509 235.863 204.159 234.295C204.808 232.728 204.064 230.931 202.496 230.282Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.96 198.302L260.706 232.391L258.267 249.406L264.662 233.451L271.96 198.302Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.993 217.181C209.647 216.148 207.718 216.402 206.685 217.748C205.653 219.094 205.906 221.022 207.252 222.055C208.598 223.088 210.527 222.834 211.56 221.488C212.593 220.142 212.339 218.214 210.993 217.181Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.367 204.269L266.673 234.284L259.913 250.088L270.22 236.332L286.367 204.269Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59 206.725C221.558 205.379 219.629 205.125 218.283 206.158C216.937 207.191 216.683 209.12 217.716 210.466C218.749 211.812 220.677 212.065 222.023 211.033C223.369 210 223.623 208.071 222.59 206.725Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.738 213.762L271.947 237.657L261.327 251.173L274.843 240.553L298.738 213.762Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.499 199.628C235.85 198.06 234.053 197.316 232.485 197.965C230.918 198.615 230.174 200.412 230.823 201.979C231.472 203.547 233.269 204.291 234.837 203.642C236.404 202.992 237.148 201.195 236.499 199.628Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.231 226.133L276.168 242.28L262.412 252.587L278.216 245.827L308.231 226.133Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.771 196.372C251.549 194.69 250.006 193.506 248.324 193.727C246.642 193.949 245.458 195.492 245.679 197.174C245.901 198.856 247.444 200.04 249.126 199.819C250.808 199.597 251.992 198.054 251.771 196.372Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.198 240.54L279.049 247.838L263.094 254.233L280.109 251.794L314.198 240.54Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.365 197.18C267.586 195.498 266.402 193.955 264.72 193.733C263.038 193.512 261.495 194.696 261.273 196.378C261.052 198.06 262.236 199.603 263.918 199.825C265.6 200.046 267.143 198.862 267.365 197.18Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.233 256L280.393 253.952L263.327 256L280.393 258.048L316.233 256Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.218 201.996C282.868 200.429 282.123 198.632 280.556 197.982C278.988 197.333 277.191 198.078 276.542 199.645C275.893 201.212 276.637 203.009 278.205 203.659C279.772 204.308 281.569 203.564 282.218 201.996Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.198 271.46L280.109 260.206L263.094 257.767L279.049 264.162L314.198 271.46Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.319 210.493C296.352 209.147 296.098 207.218 294.752 206.185C293.406 205.153 291.478 205.407 290.445 206.753C289.412 208.099 289.666 210.027 291.012 211.06C292.358 212.093 294.286 211.839 295.319 210.493Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.231 285.867L278.216 266.173L262.412 259.414L276.168 269.72L308.231 285.867Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.775 222.091C307.121 221.058 307.375 219.129 306.342 217.783C305.309 216.437 303.381 216.183 302.035 217.216C300.689 218.249 300.435 220.177 301.468 221.523C302.5 222.869 304.429 223.123 305.775 222.091Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.738 298.238L274.843 271.447L261.327 260.827L271.947 274.343L298.738 298.238Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.872 235.999C314.44 235.35 315.184 233.553 314.535 231.985C313.885 230.418 312.088 229.674 310.521 230.323C308.953 230.972 308.209 232.769 308.858 234.337C309.508 235.904 311.305 236.649 312.872 235.999Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.367 307.731L270.22 275.668L259.913 261.912L266.673 277.716L286.367 307.731Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.128 251.271C317.81 251.05 318.994 249.506 318.773 247.824C318.551 246.142 317.008 244.958 315.326 245.18C313.644 245.401 312.46 246.944 312.681 248.626C312.903 250.308 314.446 251.492 316.128 251.271Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.96 313.698L264.662 278.549L258.267 262.594L260.706 279.61L271.96 313.698Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_6632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.b5f852e63a9f5e650bfe9166f4bf235a.svg";
export { ForwardRef as ReactComponent };